import * as React from "react";
import { useAnalytics } from "../analytics-provider/analytics-provider.mjs";
const AnalyticsTrigger = (props) => {
  const { push } = useAnalytics();
  function enhanceItem(child) {
    if (React.isValidElement(child)) {
      const triggers = Array.isArray(props.trigger) ? props.trigger : [props.trigger];
      const propsWithTriggers = triggers.reduce((prevProps, currentTrigger) => {
        const { id, callback, elementId, interactionType, ...rest } = currentTrigger;
        return {
          ...prevProps,
          [callback]: (...args) => {
            push(
              typeof id === "function" ? id(args) : id,
              typeof elementId === "function" ? elementId(args) : elementId,
              typeof interactionType === "function" ? interactionType(args) : interactionType,
              rest
            );
            if (child.props[callback]) {
              child.props[callback](...args);
            }
          }
        };
      }, {});
      return React.cloneElement(child, propsWithTriggers);
    }
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, React.Children.map(props.children, enhanceItem));
};
export {
  AnalyticsTrigger
};
